import { render } from "./Orders.vue?vue&type=template&id=42497388&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"

import "./Orders.vue?vue&type=style&index=0&id=42497388&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42497388"

export default script